import { render, staticRenderFns } from "./ListSuppliesReviewCompleted.vue?vue&type=template&id=e2a778c0"
import script from "./ListSuppliesReviewCompleted.vue?vue&type=script&lang=js"
export * from "./ListSuppliesReviewCompleted.vue?vue&type=script&lang=js"
import style0 from "./ListSuppliesReviewCompleted.vue?vue&type=style&index=0&id=e2a778c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports